// Calor Piscina — scripts propios (vanilla, sin librerías externas)

function mtInitReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function mtInitCifras() {
  var els = document.querySelectorAll('.mt-cifra[data-hasta]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var hasta = parseFloat(el.getAttribute('data-hasta')) || 0;
        var sufijo = el.getAttribute('data-sufijo') || '';
        var duracion = 1200;
        var inicio = null;
        function paso(ts) {
          if (inicio === null) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var valor = Math.round(hasta * progreso);
          el.textContent = valor + sufijo;
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function mtInitGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var items = galeria.querySelectorAll('[data-mt-media-item]');
    var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!items.length || !miniaturas.length) return;
    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var target = mini.getAttribute('data-target');
        items.forEach(function (item) {
          var esActivo = item.getAttribute('data-mt-media-item') === target;
          item.classList.toggle('mt-media-activa', esActivo);
          if (!esActivo) {
            var video = item.querySelector('video');
            if (video) video.pause();
          }
        });
        miniaturas.forEach(function (m) { m.classList.remove('mt-miniatura-activa'); });
        mini.classList.add('mt-miniatura-activa');
      });
    });
  });
}

function mtInitVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var contenedor = form.closest('.mt-producto-compra') || form.parentElement || form;
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = contenedor.querySelector('[data-mt-precio]');
    var compareEl = contenedor.querySelector('[data-mt-precio-comparado]');
    var botonEl = form.querySelector('[data-mt-boton-comprar]');
    if (!dataEl || !idInput) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var selects = form.querySelectorAll('[data-mt-opcion]');
    if (!selects.length) return;

    function actualizar() {
      var seleccion = {};
      selects.forEach(function (s) {
        seleccion[s.getAttribute('data-mt-opcion')] = s.value;
      });
      var encontrada = variantes.find(function (v) {
        return v.opciones.every(function (o) { return seleccion[o.name] === o.value; });
      });
      if (!encontrada) return;
      idInput.value = encontrada.id;
      if (precioEl) precioEl.textContent = encontrada.precio_formateado;
      if (compareEl) {
        if (encontrada.comparado_formateado) {
          compareEl.textContent = encontrada.comparado_formateado;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (botonEl) {
        botonEl.disabled = !encontrada.disponible;
        botonEl.textContent = encontrada.disponible
          ? botonEl.getAttribute('data-texto-disponible')
          : botonEl.getAttribute('data-texto-agotado');
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

function mtInitAnuncioMarquee() {
  var mensaje = document.querySelector('.announcement-bar .announcement-bar__message');
  if (!mensaje || mensaje.querySelector('.mt-marquee-track')) return;
  var original = mensaje.querySelector('span');
  var texto = original ? original.textContent.trim() : '';
  if (!texto) return;

  var repeticiones = 3; // cuántas veces se ve el texto por vuelta
  var track = document.createElement('span');
  track.className = 'mt-marquee-track';
  for (var i = 0; i < repeticiones * 2; i++) {
    var item = document.createElement('span');
    item.className = 'mt-marquee-item';
    item.textContent = texto;
    track.appendChild(item);
  }
  mensaje.innerHTML = '';
  mensaje.appendChild(track);
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveals();
  mtInitCifras();
  mtInitGaleriaProducto();
  mtInitVariantes();
  mtInitAnuncioMarquee();
});
